import { FunctionComponent, PropsWithChildren, useContext } from "react";
import { hideWhenClosed } from "../../utils/hide-when-closed/hideWhenClosed";
import { FloatingPanelMenuContext } from "./FloatingPanelMenu.context";
import "./styles/floating-panel-menu-content.css";

export const FloatingPanelMenuPanel: FunctionComponent<PropsWithChildren> = (props) => {
    const floatingPanelContext = useContext(FloatingPanelMenuContext);

    if (floatingPanelContext === undefined) {
        throw new Error("Can't use FloatingPanelMenuPanel component outside of FloatingPanelMenu component.");
    }

    const { events } = floatingPanelContext;

    return (
        <div
            tabIndex={-1}
            onBlur={events.target.onFocusLoss}
            onKeyDown={(e) => events.target.onKeyDown(e, floatingPanelContext.items)}
            ref={floatingPanelContext.contentRef}
            style={hideWhenClosed(floatingPanelContext.model.isOpen)}
            className="cui-floating-panel-menu__content">
            {props.children}
        </div>
    );
};
